import {
  OEButton,
  OEModal,
  OEText,
  OETextInput,
  SelectDropdownInput,
  flex,
  mr,
  mb,
  mt,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { useState } from 'react';
import { View } from 'react-native';

import { DateTimeInput } from '../../atoms/date-time-input';
import { useMessageCompose } from '../../hooks/use-message-compose';
export interface MessageComposeModalProps {
  visible: boolean;
  onClose: () => void;
}

export const MessageComposeModal = ({
  visible,
  onClose,
}: MessageComposeModalProps) => {
  const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
  const defaultExperationDate = `${
    oneHourFromNow.toISOString().split('T')[0]
  }T${('0' + oneHourFromNow.getHours()).slice(-2)}:${(
    '0' + oneHourFromNow.getMinutes()
  ).slice(-2)}`;

  const { recipientsOptions, isSending, recipientsLabel, onChange, onSend } =
    useMessageCompose();

  const [message, setMessage] = useState('');
  const [date, setDate] = useState(defaultExperationDate);
  const handleSend = async () => {
    const expirationDateTime = new Date(date).getTime();

    if (await onSend({ message, expirationDateTime })) {
      setMessage('');
      setDate(defaultExperationDate);
      onClose();
    } else {
      alert('There was an error sending your notification. Please try again.');
    }
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <OEText style={mb(12)} fontSize={32} lineHeight={32} fontType="bold">
        Compose Message
      </OEText>
      <Label>Recipients:</Label>
      <SelectDropdownInput
        defaultButtonText={recipientsLabel}
        onSelect={onChange}
        data={recipientsOptions}
        buttonTextAfterSelection={() => recipientsLabel}
        width={520}
      />
      <OEText style={mt(5)} fontSize={10}>
        Enter recipients here... (Leave empty to send to everyone)
      </OEText>

      <Label>Expiration Date & Time:</Label>
      <View>
        <DateTimeInput value={date} onChange={setDate} name="expiration" />
      </View>

      <Label>Message:</Label>
      <OETextInput
        onChangeText={setMessage}
        mode="outlined"
        numberOfLines={4}
        value={message}
        multiline
        placeholder="Enter your message here..."
      />
      <View style={[flex('flex-row', 'justify-content-end'), mt(12)]}>
        <OEButton type="danger" style={mr(12)} onPress={onClose}>
          Cancel
        </OEButton>
        <OEButton loading={isSending} onPress={handleSend}>
          Send
        </OEButton>
      </View>
    </Modal>
  );
};
const Modal = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;

const Label = styled.Text`
  color: ${({ theme }) => theme.color.dark3};
  margin-top: 14px;
  margin-bottom: 0px;
  font-family: Poppins-Regular;
`;
